import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useDeleteProjectChecklistTemplateNotification = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['deleteProjectChecklistTemplateVersionNotification']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.deleteProjectChecklistTemplateVersionNotification,
    ...options,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: checklistTemplateKeys.getProjectVersion({
          projectId: variables.projectId,
          templateId: variables.templateId,
        }).queryKey,
      })
    },
  })
}
